/**
 * LeadForge France - Footer Component
 * With legal links and RGPD notice
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { useConfig } from '../../lib/config';
import { Database, Mail, Shield, ExternalLink } from 'lucide-react';

const Footer = () => {
  const { config, hasPhone } = useConfig();

  return (
    <footer className="bg-[#0F172A] text-white">
      <div className="container-custom py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 bg-white rounded-lg flex items-center justify-center">
                <Database className="w-5 h-5 text-[#0F172A]" />
              </div>
              <span className="font-bold text-lg">{config.app_name}</span>
            </div>
            <p className="text-[#94A3B8] max-w-md mb-6">
              {config.app_tagline}. Des millions de leads enrichis et vérifiés 
              pour accélérer votre prospection commerciale.
            </p>
            
            {/* Data source & RGPD */}
            <div className="space-y-2">
              <div className="flex items-center gap-2 text-sm text-[#64748B]">
                <Database className="w-4 h-4" />
                <span>Source des données : {config.data_source}</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-[#64748B]">
                <Shield className="w-4 h-4" />
                <span>{config.rgpd_notice}</span>
              </div>
            </div>
          </div>

          {/* Produit */}
          <div>
            <h4 className="font-semibold mb-4">Produit</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/purchase" className="text-[#94A3B8] hover:text-white transition-colors">
                  Catégories
                </Link>
              </li>
              <li>
                <Link to="/pricing-full" className="text-[#94A3B8] hover:text-white transition-colors">
                  Tarifs
                </Link>
              </li>
              <li>
                <Link to="/purchase" className="text-[#94A3B8] hover:text-white transition-colors">
                  Acheter des leads
                </Link>
              </li>
              <li>
                <Link to="/orders?email=" className="text-[#94A3B8] hover:text-white transition-colors">
                  Mon compte
                </Link>
              </li>
            </ul>
          </div>

          {/* Réseau */}
          <div>
            <h4 className="font-semibold mb-4">Nos sites</h4>
            <ul className="space-y-3">
              <li><a href="https://seodash360.com/" target="_blank" rel="noopener" className="text-[#94A3B8] hover:text-white transition-colors">SeoDash360</a></li>
              <li><a href="https://total-depannage.com/" target="_blank" rel="noopener" className="text-[#94A3B8] hover:text-white transition-colors">Total Depannage</a></li>
              <li><a href="https://cleannumerique.com/" target="_blank" rel="noopener" className="text-[#94A3B8] hover:text-white transition-colors">CleanNumerique</a></li>
            </ul>
          </div>

          {/* Légal */}
          <div>
            <h4 className="font-semibold mb-4">Légal</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/legal/cgv" className="text-[#94A3B8] hover:text-white transition-colors">
                  CGV
                </Link>
              </li>
              <li>
                <Link to="/legal/privacy" className="text-[#94A3B8] hover:text-white transition-colors">
                  Politique de confidentialité
                </Link>
              </li>
              <li>
                <Link to="/legal/mentions" className="text-[#94A3B8] hover:text-white transition-colors">
                  Mentions légales
                </Link>
              </li>
              <li>
                <a 
                  href="https://data.inpi.fr/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-[#94A3B8] hover:text-white transition-colors flex items-center gap-1"
                >
                  Source des données (INSEE SIRENE)
                  <ExternalLink className="w-3 h-3" />
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-[#1E293B] mt-12 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-sm text-[#64748B]">
            © {new Date().getFullYear()} {config.app_name}. Tous droits réservés.
          </p>
          <div className="flex items-center gap-6">
            <a 
              href={`mailto:${config.contact_email}`} 
              className="text-sm text-[#64748B] hover:text-white transition-colors flex items-center gap-2"
            >
              <Mail className="w-4 h-4" />
              {config.contact_email}
            </a>
            {hasPhone && (
              <a 
                href={`tel:${config.contact_phone}`} 
                className="text-sm text-[#64748B] hover:text-white transition-colors"
              >
                {config.contact_phone}
              </a>
            )}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
